import React, { useRef } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HomeValue() {
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        responsive: [
            {
                breakpoint: 767,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1 },
            },
        ],
    };

    const CustomArrows = () => (
        <>
            <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
                <Icons name="arrowLeft" />
            </div>
            <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
                <Icons name="arrowRight" />
            </div>
        </>
    );

    return (
        <>
            <div className="home-value">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            <h4 className="heading">Our Educational Ethos</h4>
                            <p>At Lucknow Public School, we believe education is the perfect blend of discipline, quality, and values. Guided by our motto, "Come to Learn, Go to Serve," we nurture curious minds, strong character, and compassionate hearts. Through academic excellence, ethical values, leadership, and holistic development, we empower students to become confident, responsible, and socially conscious individuals</p>
                        </div>

                        <div className="col-lg-4 col-md-4 hidefor-slider">
                            <div className="value-box wow animate__animated animate__slideInUp" data-wow-duration="1s">
                                <img src="/image/value-1.webp" className="img-responsive" alt="value" loading="lazy" />
                                <div className="valuebox-inner">
                                    <div>
                                        <h4>Vidya</h4>
                                        <span>Modern Education</span>
                                        <ul>
                                            <li>Innovation</li>
                                            <li>Technology</li>
                                            <li>Reasoning</li>
                                            <li>Globalism</li>
                                            <li>Inquiry</li>
                                        </ul>
                                    </div>
                                    <Link to={"/values"} aria-label="Know more Vidya">
                                        <Icons name="Longarrow_right" />
                                        <span className="sr-only">Know more Vidya</span>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4 hidefor-slider">
                            <div className="value-box wow animate__animated animate__slideInUp" data-wow-duration="1.1s" data-wow-delay="0.1s">
                                <img src="/image/value-2.webp" className="img-responsive" alt="value" loading="lazy" />
                                <div className="valuebox-inner">
                                    <div>
                                        <h4>Sadvidya</h4>
                                        <span>Traditional Education</span>
                                        <ul>
                                            <li>Culture</li>
                                            <li>Discipline</li>
                                            <li>Heritage</li>
                                            <li>Morality</li>
                                            <li>Respect</li>
                                        </ul>
                                    </div>
                                    <Link to={"/values"} aria-label="Know more Sadvidya">
                                        <Icons name="Longarrow_right" />
                                        <span className="sr-only">Know more Sadvidya</span>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4 hidefor-slider">
                            <div className="value-box wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.2s">
                                <img src="/image/value-3.webp" className="img-responsive" alt="value" loading="lazy" />
                                <div className="valuebox-inner">
                                    <div>
                                        <h4>Brahmavidya</h4>
                                        <span>Spiritual Education</span>
                                        <ul>
                                            <li>Awareness</li>
                                            <li>Meditation</li>
                                            <li>Wisdom</li>
                                            <li>Compassion</li>
                                            <li>Harmony</li>
                                        </ul>
                                    </div>
                                    <Link to={"/values"} aria-label="Know more Brahmavidya">
                                        <Icons name="Longarrow_right" />
                                        <span className="sr-only">Know more Brahmavidya</span>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12 mobileview-slider">
                            <Slider {...settings} ref={sliderRef}>
                                <div className="value-box">
                                    <img src="/image/value-1.webp" className="img-responsive" alt="value" loading="lazy" />
                                    <div className="valuebox-inner">
                                        <div>
                                            <h4>Vidya</h4>
                                            <span>Modern Education</span>
                                            <ul>
                                                <li>Innovation</li>
                                                <li>Technology</li>
                                                <li>Reasoning</li>
                                                <li>Globalism</li>
                                                <li>Inquiry</li>
                                            </ul>
                                        </div>
                                        <Link to={"/values"} aria-label="Know more Vidya">
                                            <Icons name="Longarrow_right" />
                                            <span className="sr-only">Know more Vidya</span>
                                        </Link>
                                    </div>
                                </div>

                                <div className="value-box">
                                    <img src="/image/value-2.webp" className="img-responsive" alt="value" loading="lazy" />
                                    <div className="valuebox-inner">
                                        <div>
                                            <h4>Sadvidya</h4>
                                            <span>Traditional Education</span>
                                            <ul>
                                                <li>Culture</li>
                                                <li>Discipline</li>
                                                <li>Heritage</li>
                                                <li>Morality</li>
                                                <li>Respect</li>
                                            </ul>
                                        </div>
                                        <Link to={"/values"} aria-label="Know more Sadvidya">
                                            <Icons name="Longarrow_right" />
                                            <span className="sr-only">Know more Sadvidya</span>
                                        </Link>
                                    </div>
                                </div>

                                <div className="value-box">
                                    <img src="/image/value-3.webp" className="img-responsive" alt="value" loading="lazy" />
                                    <div className="valuebox-inner">
                                        <div>
                                            <h4>Brahmavidya</h4>
                                            <span>Spiritual Education</span>
                                            <ul>
                                                <li>Awareness</li>
                                                <li>Meditation</li>
                                                <li>Wisdom</li>
                                                <li>Compassion</li>
                                                <li>Harmony</li>
                                            </ul>
                                        </div>
                                        <Link to={"/values"} aria-label="Know more Brahmavidya">
                                            <Icons name="Longarrow_right" />
                                            <span className="sr-only">Know more Brahmavidya</span>
                                        </Link>
                                    </div>
                                </div>
                            </Slider>
                            <CustomArrows />
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
